import { Auth } from 'aws-amplify';
import { Dropdown, DropdownButton, InputGroup } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/textLogo.svg';
import { useAppDispatch, useAppSelector } from '../../store/store';
import {
    getAuthenticatedUserEmail,
    getAuthenticatedUserName,
} from '../../store/selector/user.selector';
import { setStoreInitialState } from '../../utils/state.utils';

const PaddleHeader = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();

    const authenticatedUserName = useAppSelector(getAuthenticatedUserName);
    const authenticatedUserEmail = useAppSelector(getAuthenticatedUserEmail);

    const handleLogout = async () => {
        Auth.signOut().then(() => {
            setStoreInitialState(dispatch);
            navigate('/login', { replace: true });
        });
    };

    const redirectToRooT = () => {
        navigate('/');
    };

    return (
        <>
            <div className="tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-z-1000 tw-w-full tw-bg-gray-50 tw-flex tw-justify-between tw-items-center tw-h-12 tw-px-4 tw-border tw-border-purple-500 tw-border-opacity-20">
                <div className="tw-flex tw-items-center tw-gap-x-4">
                    <div onClick={redirectToRooT}>
                        <img src={Logo} className="tw-cursor-pointer tw-h-4 tw-w-11" />
                    </div>
                </div>

                <div className="custom_nav-profile tw-flex tw-items-center tw-gap-x-2">
                    <InputGroup className="custom-dropdown">
                        <DropdownButton
                            align="end"
                            title={<i className="ph ph-user lg"></i>}
                            id="dropdown-menu-align-end"
                            className="dropdown__toggle"
                        >
                            <Dropdown.Header className="mt-2 mb-2">
                                <h3 className="fw-semibold ">{authenticatedUserName}</h3>
                                <p className="text-muted m-0 ">{authenticatedUserEmail}</p>
                            </Dropdown.Header>
                            <Dropdown.Item onClick={handleLogout}>
                                <i className="pxi-log-out-2 sm"></i> Sign out
                            </Dropdown.Item>
                        </DropdownButton>
                    </InputGroup>
                </div>
            </div>
        </>
    );
};
export default PaddleHeader;
